(function () {
  'use strict';
  const Core = window.PL8WholesaleCore;
  if (!Core) return;
  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    const catalog = window.PL8WholesaleCatalog?.read(root);
    if (!catalog) return;
    const words = JSON.parse(root.querySelector('[data-pl8-words]').textContent);
    const one = selector => root.querySelector(selector);
    const all = selector => Array.from(root.querySelectorAll(selector));
    const inputs = all('[data-qty]');
    const cards = all('[data-card]');
    if (catalog.length < 1 || catalog.length > 2048 || inputs.length !== catalog.length) return;
    root.dataset.initialized = 'true';
    inputs.forEach(input => { input.disabled = false; });
    const money = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
    const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll('{' + name + '}', String(replacement)), words[key] || key);
    const raw = () => inputs.map(input => input.value);
    let target = 10;
    let reviewOpen = false;
    let errorsShown = false;
    const reviewDialog = one('[data-review-dialog]');
    const resetDialog = one('[data-reset-dialog]');
    const errors = one('[data-errors]');
    const business = one('[data-business]');
    const accepted = one('[data-accept]');
    const search = one('[data-search]');
    const region = one('[data-region]');
    const country = one('[data-country]');
    const selectedOnly = one('[data-selected-only]');
    const reviewButton = one('[data-review]');
    function filter() {
      const filters = { query: search.value, region: region.value, country: country.value, selectedOnly: selectedOnly.checked };
      let visible = 0;
      cards.forEach((card, index) => {
        const show = Core.matches(catalog[index], filters, inputs[index].value);
        card.hidden = !show;
        if (show) visible += 1;
      });
      one('[data-empty]').hidden = visible > 0;
      one('[data-results]').textContent = text('results', { visible });
    }
    function clearError() {
      errorsShown = false;
      errors.hidden = true;
      errors.textContent = '';
      business.removeAttribute('aria-invalid');
      accepted.removeAttribute('aria-invalid');
    }
    function update() {
      const result = Core.calculate(raw());
      inputs.forEach((input, index) => {
        const parsed = Core.parseQuantity(input.value);
        input.setAttribute('aria-invalid', String(!parsed.valid));
        one('[data-qty-error="' + index + '"]').hidden = parsed.valid;
        one('[data-minus="' + index + '"]').disabled = !parsed.valid || parsed.value === 0;
        one('[data-plus="' + index + '"]').disabled = !parsed.valid || parsed.value >= 50;
        cards[index].classList.toggle('pl8w__card--selected', parsed.valid && parsed.value > 0);
      });
      const completeQuantity = result.invalidIndexes.length === 0;
      one('[data-total-qty]').textContent = completeQuantity ? result.quantity : '—';
      one('[data-mobile-qty]').textContent = completeQuantity ? result.quantity : '—';
      one('[data-mobile-total]').textContent = result.subtotal === null ? '—' : money.format(result.subtotal);
      one('[data-design-count]').textContent = result.designCount;
      one('[data-unit]').textContent = result.unitPrice === null ? '—' : money.format(result.unitPrice);
      one('[data-subtotal]').textContent = result.subtotal === null ? '—' : money.format(result.subtotal);
      one('[data-shipping]').textContent = result.valid ? text('free') : text('pending');
      const progress = one('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(50, result.quantity)));
      progress.firstElementChild.style.width = Math.min(100, result.quantity / 50 * 100) + '%';
      let guidance = text('empty');
      if (!completeQuantity) guidance = text('invalid_qty');
      else if (result.quantity > 50) guidance = text('too_many');
      else if (result.valid) guidance = text('valid', { qty: result.quantity });
      else if (result.quantity > 0) guidance = text('next', { qty: result.nextTier, remaining: result.remaining });
      one('[data-guidance]').textContent = guidance;
      one('[data-guidance]').classList.toggle('pl8w__warning', !completeQuantity || result.quantity > 50);
      one('[data-target-status]').textContent = text('target', { qty: target, total: completeQuantity ? result.quantity : '—' });
      one('[data-selected-summary]').textContent = text('selected_count', { count: result.designCount, qty: completeQuantity ? result.quantity : '—' });
      all('[data-tier]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.tier) === target));
        button.classList.toggle('pl8w__tier--current', result.valid && Number(button.dataset.tier) === result.quantity);
      });
      if (errorsShown) clearError();
      filter();
      root.dispatchEvent(new CustomEvent('pl8:selectionchange'));
    }
    function showErrors(messages, focusTarget) {
      errors.textContent = messages.join(' ');
      errors.hidden = false;
      errorsShown = true;
      if (focusTarget) focusTarget.focus();
      else errors.focus();
    }
    inputs.forEach((input, index) => {
      input.addEventListener('input', update);
      input.addEventListener('blur', () => {
        const parsed = Core.parseQuantity(input.value);
        if (parsed.valid) input.value = String(parsed.value);
      });
      const adjust = delta => {
        const parsed = Core.parseQuantity(input.value);
        if (!parsed.valid) return;
        input.value = String(Math.max(0, Math.min(50, parsed.value + delta)));
        update();
      };
      one('[data-minus="' + index + '"]').addEventListener('click', () => adjust(-1));
      one('[data-plus="' + index + '"]').addEventListener('click', () => adjust(1));
      input.addEventListener('keydown', event => {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          event.preventDefault();
          adjust(event.key === 'ArrowUp' ? 1 : -1);
        }
      });
    });
    all('[data-tier]').forEach(button => button.addEventListener('click', () => {
      target = Number(button.dataset.tier);
      update();
    }));
    search.addEventListener('input', filter);
    [region, country, selectedOnly].forEach(input => input.addEventListener('change', filter));
    one('[data-clear-filters]').addEventListener('click', () => {
      search.value = '';
      region.value = 'all';
      country.value = 'all';
      selectedOnly.checked = false;
      filter();
      search.focus();
    });
    business.addEventListener('input', clearError);
    accepted.addEventListener('change', clearError);
    reviewButton.addEventListener('click', () => {
      if (reviewOpen) return;
      const result = Core.calculate(raw());
      const messages = [];
      let focusTarget;
      if (result.invalidIndexes.length) {
        messages.push(text('invalid_qty'));
        const index = result.invalidIndexes[0];
        cards[index].hidden = false;
        focusTarget = inputs[index];
      } else if (!result.valid) messages.push(text('invalid_total'));
      if (!business.value.trim()) {
        messages.push(text('required_business'));
        business.setAttribute('aria-invalid', 'true');
        focusTarget = focusTarget || business;
      }
      if (!accepted.checked) {
        messages.push(text('required_accept'));
        accepted.setAttribute('aria-invalid', 'true');
        focusTarget = focusTarget || accepted;
      }
      if (messages.length) {
        showErrors(messages, focusTarget);
        return;
      }
      clearError();
      one('[data-review-business]').textContent = business.value.trim();
      const list = one('[data-review-items]');
      list.replaceChildren();
      inputs.forEach((input, index) => {
        const qty = Core.parseQuantity(input.value).value;
        if (!qty) return;
        const item = document.createElement('li');
        const name = document.createElement('span');
        const quantity = document.createElement('strong');
        name.textContent = catalog[index].designName;
        quantity.textContent = qty + text('pieces');
        item.append(name, quantity);
        list.append(item);
      });
      one('[data-review-total]').textContent = text('total_label') + ' ' + result.quantity + text('pieces') + ' / ' + money.format(result.subtotal);
      reviewOpen = true;
      reviewDialog.showModal();
    });
    all('[data-close-review]').forEach(button => button.addEventListener('click', () => reviewDialog.close()));
    reviewDialog.addEventListener('close', () => {
      reviewOpen = false;
      reviewButton.focus();
    });
    one('[data-reset]').addEventListener('click', () => {
      if (!resetDialog.open) resetDialog.showModal();
    });
    one('[data-cancel-reset]').addEventListener('click', () => resetDialog.close());
    one('[data-confirm-reset]').addEventListener('click', () => {
      inputs.forEach(input => { input.value = '0'; });
      clearError();
      update();
      one('[data-reset-status]').textContent = text('cleared');
      resetDialog.close();
    });
    resetDialog.addEventListener('close', () => one('[data-reset]').focus());
    one('[data-jump-summary]').addEventListener('click', () => {
      const heading = one('.pl8w__order h2');
      const reducedMotion = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      heading.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      heading.focus({ preventScroll: true });
    });
    root.addEventListener('submit', event => event.preventDefault());
    all('.pl8w__card-image img').forEach(image => image.addEventListener('error', () => {
      image.alt = text('image_unavailable');
      image.parentElement.classList.add('pl8w__image-failed');
    }));
    reviewButton.disabled = false;
    update();
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-pl8-wholesale]')) initialize(scope);
    scope.querySelectorAll('[data-pl8-wholesale]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
